/****************************************************************
 * Js imports
 ****************************************************************/

/****************************************************************
 * CODE reorder
 ****************************************************************/

!(function ($, document, window, undefined) {

  /**
   * Plugin name
   */
  var _pluginName = 'reorder';

  /**
   * @param jQuery Element Wrapping container div
   * @return reorder_plugin
   */
  var reorder_plugin = function ($element, options) {

    // scope it
    var self = this;
    self.$element = $element;
    self.$trigger = self.$element.find('[data-reorder-trigger]');
    self.$errorPopup = self.$element.find('[data-reorder-error="wrapper"]')

    self.$errorQueue = [];
      
    // get options
    var defaults = {};
    var metaOptions = self.$element.data('reorder-options');
    self.options = $.extend({}, defaults, metaOptions);

    if ($.code.debug) {
      console.log('Init reorder:', self.$element, self.options);
    }

    self.init();
  };

  /**
   * Render products
   *
   * @return void
   * @access public
   */
  reorder_plugin.prototype.init = function () {
    var self = this;

    // Catch click on element (trigger)
    self.$trigger.on('click', function(event) {
      event.preventDefault();

      // get the add to cart queue
      var addToCartQueue = self.getAddToCartQueueArray();

      if ($.code.debug) {
        console.log('Reorder addToCart queue: ', addToCartQueue);
      }

      // Disable the trigger
      self.disableTrigger();

      // loop through the add to cart queue
      self.loopThroughAddToCartQueue(addToCartQueue);
    });
  };

  /**
   * Get the add to cart queue from the order history products
   *
   * @return array
   * @access public
   */
  reorder_plugin.prototype.getAddToCartQueueArray = function () {
    var self = this;

    // init
    var data = self.options;
    var addToCartQueue = [];

    for (var line_item in data) {

      // push data to queue
      addToCartQueue.push(data[line_item]);
    }

    // return the queue
    return addToCartQueue;
  };

  /**
   * Loop through add to cart queue
   *
   * @return void
   * @access public
   */
  reorder_plugin.prototype.loopThroughAddToCartQueue = function (addToCartQueue) {
    var self = this;

    // Check if queue is not empty, otherwise go to cart
    if (addToCartQueue.length) {
      var request = addToCartQueue.shift();
      self.addToCart(request, addToCartQueue);
    } else {

      // enable the trigger
      self.enableTrigger();

      // Check if there are any errors
      if (self.$errorQueue.length) {

        // Grab all errors and append to popup content
        for ( var error_item in self.$errorQueue) {
          var errorStr = '<p class="product">' + self.$errorQueue[error_item].title + '</p><hr/>';
          self.$errorPopup.find('[data-reorder-error="content"]').prepend(errorStr);
        }
        
        // Open error popup
        $.fancybox.open(self.$errorPopup, {baseClass: "product-link-popup"});

        // Clear the error queue
        self.$errorQueue = [];
        
      } else {
        // go directly to the cart
        document.location.href = '/cart';
      }
    }
  };

  /**
   * Disable the button
   *
   * @return void
   * @access public
   */
  reorder_plugin.prototype.disableTrigger = function () {
    var self = this;

    self.$element.addClass('disabled').prop('disabled', true);
  };

  /**
   * Enable the button
   *
   * @return void
   * @access public
   */
  reorder_plugin.prototype.enableTrigger = function () {
    var self = this;

    self.$element.removeClass('disabled').prop('disabled', false);
  };

  /**
   * Add to cart
   *
   * @return void
   * @access public
   */
  reorder_plugin.prototype.addToCart = function (request, addToCartQueue) {
    var self = this;

    // Create new object specially for ajax add.js call
    var addRequest = $.extend({}, {}, request);
    delete addRequest['title'];
    delete addRequest['sku'];

    // do ajax call
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: addRequest,
      dataType: 'json',
      success: function(result) {
        if ($.code.debug) {
          console.log('added to cart: ', result);
        }
        
        // Continue looping
        self.loopThroughAddToCartQueue(addToCartQueue);
      },
      error: function(result) {
        if ($.code.debug) {
          console.log('Failed to add to cart:', request, result);
        }

        // Add error to error queue
        self.$errorQueue.push(request);

        // Continue looping
        self.loopThroughAddToCartQueue(addToCartQueue);
      }
    });
  };

  /**
   * reorder plugin
   *
   * @return jQuery objects
   */
  $.fn.reorder = function (options) {

    // put args in array
    var args = Array.prototype.slice.call(arguments, 1);

    // initialize the items
    return this.each(function () {

      // store the element the plugin is set on
      var $element = $(this);

      // guard if plugin was already initted
      var instance = $element.data('plugin_' + _pluginName);

      // if plugin was not innited
      if (!instance) {

        // init plugin on element and set guard data on element
        $element.data('plugin_' + _pluginName, new reorder_plugin($element, options));
      } else {

        // if instance already created call method from plugin
        if (typeof options === 'string') {
          instance[options].apply(instance, args);
        }
      }
    });
  };  
})(jQuery, document, window);  


/****************************************************************
 * CODE customers account
 ****************************************************************/
$.code.customerAccountInit = function() {
  
  (function() {

    // Init reorder
    $('[data-reorder-wrapper]').reorder();
   
  })();


};

$.code.customerAccountInit();

// Call init after theme editor changes.
if(Shopify.designMode) {
  $(document).on('shopify:section:load', function (e) {
    $.code.customerAccountInit();
  });
}
